export default __webpack_public_path__ + "static/media/cta.57cb1bc1.png";